import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Basic from '../_layout';
import generator from '../_layout/util';
import AutoHeight from './AutoHeight';


class Layout extends React.PureComponent {
  /** *******************static************************** */
  static propTypes = {
    prefixCls: PropTypes.string,
    hasHead: PropTypes.bool,
  };

  static defaultProps = {
    prefixCls: 'mkui-layout-list',
    hasHead: false,
  };

  render(){
    const { prefixCls, hasHead, children} = this.props;
    const wrapperCls = classNames(`${prefixCls}`, {
      [`${prefixCls}-has-head`]: hasHead === true,
    });
    return <div className={wrapperCls}>{children}</div>
  }
}

const Header = generator({
  prefixCls: 'mkui-layout-list-header',
})(Basic);
const Content = generator({
  prefixCls: 'mkui-layout-list-content',
})(Basic);
const ToolBar = generator({
  prefixCls: 'mkui-layout-list-content-toolbar',
})(Basic);
const Filter = generator({
  prefixCls: 'mkui-layout-list-content-filter',
})(Basic);
const Table = generator({
  prefixCls: 'mkui-layout-list-content-table',
})(Basic);
Content.ListToolBar = ToolBar;
Content.ListFilterWrapper = Filter;
Content.ListTableWrapper = Table;
Layout.ListHeader = Header;
Layout.ListContent = Content;
Layout.AutoHeight = AutoHeight;
export default Layout;
